import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  value: [],
  activated: null,
  tenansListv2 : [],
  activeTenantsListv2 : []
};

const tenantSlice = createSlice({
  name: 'tenant',
  initialState,
  reducers: {
    addTenant: (state, action) => {
      state.value = action.payload; 
    },
    activateTenant: (state, action) => {
      state.activated = action.payload;
    },
    setTenantsListv2 : (state, action : any) =>{
      state.tenansListv2 = action.payload;
  },
  setActiveTenantsListv2 : (state, action : any) =>{
      state.activeTenantsListv2 = action.payload;
  }
  },
});

// Export actions
export const { addTenant, activateTenant,setActiveTenantsListv2,setTenantsListv2 } = tenantSlice.actions;

export default tenantSlice.reducer;